module.exports = __webpack_public_path__ + "static/media/16_tn.258eaba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/16_tn.jpg
// module id = 230
// module chunks = 0